import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgAddApp } from '../ts-client/tx';
import { MsgAddApp as MsgAddAppProto } from '../proto/tx_pb';

const MSG_ADD_APP_TYPES = (message: MsgAddApp) => ({
  MsgValue: [
    { name: 'creator', type: 'string' },
    { name: 'name', type: 'string' },
    { name: 'rollapp_id', type: 'string' },
    ...(message.description ? [ { name: 'description', type: 'string' } ] : []),
    { name: 'image', type: 'string' },
    { name: 'url', type: 'string' },
    ...(message.order ? [ { name: 'order', type: 'int32' } ] : []),
  ],
});

export const createTxMsgAddApp = (context: TxContext, params: MsgAddApp): TxPayload => {
  const typedData = createEIP712MsgAddApp(context, params);
  const cosmosMsg = createCosmosMsgAddApp(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgAddApp = (context: TxContext, params: MsgAddApp): EIP712TypedData => {
  const types = generateTypes(MSG_ADD_APP_TYPES(params));
  const message = createMsgAddApp(params);
  return { types, message };
};

const createCosmosMsgAddApp = (context: TxContext, params: MsgAddApp): any => {
  const message = new MsgAddAppProto({
    creator: params.creator,
    name: params.name,
    rollappId: params.rollappId,
    description: params.description,
    image: params.image,
    url: params.url,
    order: params.order,
  });
  return { message, path: MsgAddAppProto.typeName };
};

function createMsgAddApp(params: MsgAddApp): object | object[] {
  return {
    type: 'rollapp/AddApp',
    value: {
      creator: params.creator,
      name: params.name,
      rollapp_id: params.rollappId,
      ...(params.description && { description: params.description }),
      image: params.image,
      url: params.url,
      ...(params.order && { order: params.order }),
    },
  };
}
